import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import 'react-phone-input-2/lib/bootstrap.css';
import * as Yup from 'yup';
import { AuthFooter, Form, Wrapper } from 'components';
import useQuery from 'hooks/useQuery';
import { LOGIN } from 'constants/routes';
import FullPageCardContainer from 'components/FullPageCardContainer/FullPageCardContainer';
import { useRegister } from 'api/auth/hooks';

const RegisterPage = () => {
  const { t } = useTranslation(['pages']);
  const query = useQuery();
  const { mutate: registerUser, isPending } = useRegister();
  return (
    <FullPageCardContainer
      xs="12"
      md="8"
      lg="6"
      footer={AuthFooter}
      variant="auth"
      cornerAction={{ label: 'Log in', to: LOGIN }}
    >
      <h1 className="auth-page-title">{t('adminRegistration.register')}</h1>
      <p className="auth-page-subtitle">{t('login.signUp')}</p>
      <Form
        initialValues={{
          name: query.get('name') || '',
          last_name: query.get('last_name') || '',
          email: query.get('email') || '',
          password: '',
          password_repeat: '',
          countryCode: '',
        }}
        onSubmit={async (values) => {
          registerUser(values);
        }}
        validationSchema={Yup.object({
          name: Yup.string()
            .min(3, t('validation:atLeastChars', { number: 3 }))
            .required(t('validation:required')),
          last_name: Yup.string()
            .min(3, t('validation:atLeastChars', { number: 3 }))
            .required(t('validation:required')),
          email: Yup.string().email('Invalid email address').required(t('validation:required')),
          password: Yup.string()
            .min(8, t('validation:atLeastChars', { number: 8 }))
            .required(t('validation:required')),
          password_repeat: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required(t('validation:required')),
        })}
        renderDefaultButtons={false}
      >
        <Form.Group>
          <Form.Label>{t('adminRegistration.name')}</Form.Label>
          <Form.Input name="name" type="text" placeholder="John" />
        </Form.Group>
        <Form.Group>
          <Form.Label>{t('adminRegistration.lastName')}</Form.Label>
          <Form.Input name="last_name" type="text" placeholder="Doe" />
        </Form.Group>
        <Form.Group>
          <Form.Label>{t('adminRegistration.email')}</Form.Label>
          <Form.Input
            name="email"
            type="email"
            placeholder="johndoe@rambla.com"
            autocomplete="off"
          />
        </Form.Group>
        <Form.Group>
          <Row>
            <Col>
              <Form.Label>{t('adminRegistration.password')}</Form.Label>
            </Col>
          </Row>
          <Form.Input
            type="password"
            name="password"
            placeholder={t('adminRegistration.passwordPlaceholder')}
            autocomplete="new-password"
          />
        </Form.Group>
        <Form.Group>
          <Row>
            <Col>
              <Form.Label>{t('adminRegistration.rePassword')}</Form.Label>
            </Col>
          </Row>
          <Form.Input
            type="password"
            name="password_repeat"
            placeholder={t('adminRegistration.rePasswordPlaceholder')}
            autocomplete="new-password"
          />
        </Form.Group>

        <Wrapper mb-3>
          <Form.Submit
            style={{ width: '100%' }}
            size="lg"
            variant="primary"
            isLoading={isPending}
            ignoreClickedState
          >
            {t('adminRegistration.signUp')}
          </Form.Submit>
        </Wrapper>
      </Form>
    </FullPageCardContainer>
  );
};

export default RegisterPage;
